import { Suspense, lazy, ElementType } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import MainLayout from '../layouts/main';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// guards
import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// config
import { PATH_AFTER_LOGIN } from '../config';
// components
import LoadingScreen from '../components/LoadingScreen';
import Permission from 'src/sections/@dashboard/permission/Permission';
import RoleDetailHeader from 'src/sections/@dashboard/role/roleForm/RoleDetailHeader';
import ChangePasswordForm from 'src/sections/@dashboard/user/userForm/ChangePasswordForm';
import PasswordReset from 'src/sections/@dashboard/user/userList/PasswordReset';
import UserProfile from 'src/sections/@dashboard/user/userList/UserProfile';

import PermissionBasedGuard from '../guards/PermissionBasedGuard';
import DistrictCreate from 'src/sections/@dashboard/district/districtForm/DistrictCreate';
import DistrictList from 'src/sections/@dashboard/district/districtList/DistrictList';
import PositionTitleList from 'src/sections/@dashboard/PositionTitle/PositionTitleList/PositionTitleList';
import PositionTitleCreate from 'src/sections/@dashboard/PositionTitle/PositionTitleForm/PositionTitleCreate';
import JobPositionList from 'src/sections/@dashboard/JobPosition/JobPositionList/JobPositionList';
import JobPositionCreate from 'src/sections/@dashboard/JobPosition/JobPositionForm/JobPositionCreate';
import ContractDetailsCreate from 'src/sections/@dashboard/ContractDetails/ContractDetailsForm/ContractDetailsCreate';
import ContractDetailsList from 'src/sections/@dashboard/ContractDetails/ContractDetailsList/ContractDetailsList';
import EmployeeDetailHeader from 'src/sections/@dashboard/Employee/EmployeeForm/EmployeeDetailHeader';

import GoogleAuthCreate from 'src/sections/@dashboard/user/userForm/GoogleAuthCreate';
import ApplicationList from 'src/sections/@dashboard/applicationApi/applicationList/ApplicationList';
import ApplicationCreate from 'src/sections/@dashboard/applicationApi/applicationForm/ApplicationCreate';
import TrainingVideoList from 'src/sections/@dashboard/trainingVideo/trainingVideoList/TrainingVideoList';
import TrainingVideoCreate from 'src/sections/@dashboard/trainingVideo/trainingVideoForm/TrainingVideoCreate';
import TrainingVideoHeader from 'src/sections/@dashboard/trainingVideo/trainingVideoForm/TrainingVideoPlayerHeader';
import POSList from 'src/sections/@dashboard/Resturant/POS/POSList/POSList';
import POSCreate from 'src/sections/@dashboard/Resturant/POS/POSForm/POSCreate';
import BlockList from 'src/sections/@dashboard/Choqorak/Settings/Block/BlockList/BlockList';
import BlockCreate from 'src/sections/@dashboard/Choqorak/Settings/Block/BlockForm/BlockCreate';
import ContractInfoCreate from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoForm/ContractInfoCreate';
import ContractInfoList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/ContractInfoList';
import CustomerCreate from 'src/sections/@dashboard/Choqorak/MainTable/Customer/CustomerForm/CustomerCreate';
import IncomeCreate from 'src/sections/@dashboard/Choqorak/MainTable/Income/IncomeForm/IncomeCreate';
import IncomeList from 'src/sections/@dashboard/Choqorak/MainTable/Income/IncomeList/IncomeList';
import ShopCreate from 'src/sections/@dashboard/Choqorak/MainTable/Shop/ShopForm/ShopCreate';
import ShopList from 'src/sections/@dashboard/Choqorak/MainTable/Shop/ShopList/ShopList';
import ElectricBoxCreate from 'src/sections/@dashboard/Choqorak/Settings/ElectricBox/ElectricBoxForm/ElectricBoxCreate';
import ElectricBoxList from 'src/sections/@dashboard/Choqorak/Settings/ElectricBox/ElectricBoxList/ElectricBoxList';
import ElectricMeterCreate from 'src/sections/@dashboard/Choqorak/Settings/ElectricMeter/ElectricMeterForm/ElectricMeterCreate';
import ElectricMeterList from 'src/sections/@dashboard/Choqorak/Settings/ElectricMeter/ElectricMeterList/ElectricMeterList';
import FloorCreate from 'src/sections/@dashboard/Choqorak/Settings/Floor/FloorForm/FloorCreate';
import FloorList from 'src/sections/@dashboard/Choqorak/Settings/Floor/FloorList/FloorList';
import IncomeCategoryCreate from 'src/sections/@dashboard/Choqorak/Settings/IncomeCategory/IncomeCategoryForm/IncomeCategoryCreate';
import IncomeCategoryList from 'src/sections/@dashboard/Choqorak/Settings/IncomeCategory/IncomeCategoryList/IncomeCategoryList';
import ShopContractTypeCreate from 'src/sections/@dashboard/Choqorak/Settings/ShopContractType/ShopContractTypeForm/ShopContractTypeCreate';
import ShopContractTypeList from 'src/sections/@dashboard/Choqorak/Settings/ShopContractType/ShopContractTypeList/ShopContractTypeList';
import StatusCreate from 'src/sections/@dashboard/Choqorak/Settings/Status/StatusForm/StatusCreate';
import StatusList from 'src/sections/@dashboard/Choqorak/Settings/Status/StatusList/StatusList';
import ShopTypeCreate from 'src/sections/@dashboard/Choqorak/Settings/ShopType/ShopTypeForm/ShopTypeCreate';
import ShopTypeList from 'src/sections/@dashboard/Choqorak/Settings/ShopType/ShopTypeList/ShopTypeList';
import CustomerDetailHeader from 'src/sections/@dashboard/Choqorak/MainTable/Customer/CustomerForm/CustomerDetailHeader';
import CustomerList from 'src/sections/@dashboard/Choqorak/MainTable/Customer/CustomerList/CustomerList';
import ChoqoralMap from 'src/sections/@dashboard/Choqorak/MainTable/ChoqorakMap/ChoqorakMap';
import BlockDetailHeader from 'src/sections/@dashboard/Choqorak/Settings/Block/BlockDetails/BlockDetailHeader';
import ContractInfoDetailHeader from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoDetails/ContractInfoDetailHeader';
import IncomeDetailHeader from 'src/sections/@dashboard/Choqorak/MainTable/Income/IncomeDetails/IncomeDetailHeader';
import ShopDetailHeader from 'src/sections/@dashboard/Choqorak/MainTable/Shop/ShopDetails/ShopDetailHeader';
import ElectricBoxDetailHeader from 'src/sections/@dashboard/Choqorak/Settings/ElectricBox/ElectricBoxDetails/ElectricBoxDetailHeader';
import ElectricMeterDetailHeader from 'src/sections/@dashboard/Choqorak/Settings/ElectricMeter/ElectricMeterDetails/ElectricMeterDetailHeader';
import FloorDetailHeader from 'src/sections/@dashboard/Choqorak/Settings/Floor/FloorDetails/FloorDetailHeader';
import RentPaymentCreate from 'src/sections/@dashboard/Choqorak/MainTable/RentPayment/RentPaymentForm/RentPaymentCreate';
import RentPaymentList from 'src/sections/@dashboard/Choqorak/MainTable/RentPayment/RentPaymentList/RentPaymentList';
import RentPaymentSearchIndex from 'src/sections/@dashboard/Choqorak/MainTable/RentPayment/RentPaymentSearchForm/RentPaymentSearchIndex';
import PDFViewer from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/documentViewer/DocumentViewers';
import ProvinceCreate from 'src/sections/@dashboard/province/provinceForm/ProvinceCreate';
import ProvinceList from 'src/sections/@dashboard/province/provinceList/ProvinceList';
import TermsAndConditionCreate from 'src/sections/@dashboard/Choqorak/Settings/TermsAndCondition/TermsAndConditionForm/TermsAndConditionCreate';
import TermsAndConditionList from 'src/sections/@dashboard/Choqorak/Settings/TermsAndCondition/TermsAndConditionList/TermsAndConditionList';
import ElectricityPaymentList from 'src/sections/@dashboard/Choqorak/MainTable/ElectricityPayment/ElectricityPaymentList/ElectricityPaymentList';
import NPFXDashboard from 'src/sections/@dashboard/Choqorak/Dashboards/ChoqorakDashboard';
import RentPaymentReportIndex from 'src/sections/@dashboard/Choqorak/Reports/RentPaymentReport/RentPaymentReportIndex';
import ContractInfoReportIndex from 'src/sections/@dashboard/Choqorak/Reports/ContractInfoReport/ContractInfoReportIndex';
import ElectricityPaymentReportIndex from 'src/sections/@dashboard/Choqorak/Reports/ElectricityPaymentReport/ElectricityPaymentReportIndex';
import IncomeReportIndex from 'src/sections/@dashboard/Choqorak/Reports/IncomeReport/IncomeReportIndex';
import ShopReportIndex from 'src/sections/@dashboard/Choqorak/Reports/ShopReport/ShopReportIndex';
import ContractInfoUnApprovedList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/NeedApproval/ContractInfoUnApprovedList';
import ContractInfoExpiredList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/Expired/ContractInfoExpiredList';
import ContractInfoAboutToExpiredList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/AboutToExpired/ContractInfoAboutToExpiredList';
import ContractInfoApprovedList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/Approved/ContractInfoApprovedList';
import ContractInfoTerminatedList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/Terminated/ContractInfoTerminatedList';
import ElectricityConsumptionList from 'src/sections/@dashboard/Choqorak/MainTable/ElectricityPayment/ElectricityPaymentList/ElectricityConsumptionList';
import ContractInfoActiveContractList from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoList/ActiveContract/ContractInfoActiveContractList';
import ExpirationSettlementCreate from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ExpirationSettlementForm/ExpirationSettlementCreate';
import ContractInfoTerminateCreate from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/ContractInfoTerminateForm copy/ContractInfoTerminateCreate';
import DiscountDocView from 'src/sections/@dashboard/Choqorak/MainTable/ContractInfo/documentViewer/DiscountDocView';
import FinancialPaymentDetailHeader from 'src/sections/@dashboard/Choqorak/MainTable/FinancialPayment/FinancialPaymentDetails/FinancialPaymentDetailHeader';
import FinancialPaymentCreate from 'src/sections/@dashboard/Choqorak/MainTable/FinancialPayment/FinancialPaymentForm/FinancialPaymentCreate';
import FinancialPaymentList from 'src/sections/@dashboard/Choqorak/MainTable/FinancialPayment/FinancialPaymentList/FinancialPaymentList';

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  // eslint-disable-next-line react-hooks/rules-of-hooks

  const isDashboard = pathname.includes('/dashboard');

  return (
    <Suspense fallback={<LoadingScreen isDashboard={isDashboard} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: 'auth',
      children: [
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: 'register',
          element: (
            <GuestGuard>
              <Register />
            </GuestGuard>
          ),
        },
        { path: 'login-unprotected', element: <Login /> },
        { path: 'register-unprotected', element: <Register /> },
        { path: 'reset-password', element: <ResetPassword /> },
        { path: 'new-password', element: <NewPassword /> },
        { path: 'verify', element: <VerifyCode /> },
      ],
    },

    // Dashboard Routes
    {
      path: 'Dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
        { path: 'app', element: <NPFXDashboard /> },
        { path: 'ecommerce', element: <GeneralEcommerce /> },
        { path: 'analytics', element: <GeneralAnalytics /> },
        { path: 'banking', element: <GeneralBanking /> },
        { path: 'booking', element: <GeneralBooking /> },

        {
          path: 'e-commerce',
          children: [
            { element: <Navigate to="/dashboard/e-commerce/shop" replace />, index: true },
            { path: 'shop', element: <EcommerceShop /> },
            { path: 'product/:name', element: <EcommerceProductDetails /> },
            { path: 'list', element: <EcommerceProductList /> },
            { path: 'product/new', element: <EcommerceProductCreate /> },
            { path: 'product/:name/edit', element: <EcommerceProductCreate /> },
            { path: 'checkout', element: <EcommerceCheckout /> },
          ],
        },

        // NPFX MARKET COMPONENT RENDERING FOR ROUTES HERE

        // Asset Type Routs

        {
          path: 'permission',
          children: [
            { element: <Navigate to="/dashboard/permission/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Permission-GetList']}>
                  <PermissionList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'PermissionFrom/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Permission-Create']}>
                  <PermissionFrom />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'Permission/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Permission-Update']}>
                  <PermissionFrom />
                </PermissionBasedGuard>
              ),
            },
            //{ path: ':id', element: <InvoiceDetails /> },
            // { path: ':id/edit', element: <InvoiceEdit /> },
            //{ path: 'new', element: <PermissionCreate /> },
          ],
        },

        // Language
        {
          path: 'Language',
          children: [
            { element: <Navigate to="/dashboard/Language/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Language-GetList']}>
                  <LanguageList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'LanguageCreate/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Language-Create']}>
                  <LanguageCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'Language/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Language-Update']}>
                  <LanguageCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        {
          path: 'permission',
          children: [
            { element: <Navigate to="/dashboard/permission/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Permission-GetList']}>
                  <Permission />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        // Role
        {
          path: 'Role',
          children: [
            { element: <Navigate to="/dashboard/Role/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Role-GetList']}>
                  <RoleList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'RoleCreate/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Role-Create']}>
                  <RoleCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'Role/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Role-Update']}>
                  <RoleCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'Role/detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Role-GetDetails']}>
                  <RoleDetailHeader />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'Province',
          children: [
            {
              element: (
                <PermissionBasedGuard hasContent permissions={['Province-GetList']}>
                  <Navigate to="/dashboard/Province/list" replace />
                </PermissionBasedGuard>
              ),
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Province-GetList']}>
                  <ProvinceList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Province-Create']}>
                  <ProvinceCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Province-Update']}>
                  <ProvinceCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'District',
          children: [
            {
              element: (
                <PermissionBasedGuard hasContent permissions={['District-GetList']}>
                  <Navigate to="/dashboard/District/list" replace />
                </PermissionBasedGuard>
              ),
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-GetList']}>
                  <DistrictList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'district/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-Create']}>
                  <DistrictCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'district/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-Update']}>
                  <DistrictCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        // User
        {
          path: 'User',
          children: [
            { element: <Navigate to="/dashboard/User/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-GetList']}>
                  <UserList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'GoogleAuth',
              element: (
                // <PermissionBasedGuard hasContent permissions={['User-GetList']}>
                <GoogleAuthCreate />
                // </PermissionBasedGuard>
              ),
            },
            {
              path: 'Loglist',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-UserLog']}>
                  <UserLogList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'profile/:id',
              element: (
                <PermissionBasedGuard hasContent permissions={['Profile-Profile']}>
                  <UserProfile />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'UserCreate/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-Create']}>
                  <UserCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-Update']}>
                  <UserCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail/:id',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-GetDetails']}>
                  <UserDetailHeader />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'ChangePassword/changePassword',
              element: <ChangePasswordForm />,
            },
            {
              path: 'ResetPassword/resetPassword',
              element: (
                <PermissionBasedGuard hasContent permissions={['User-PasswordReset']}>
                  <PasswordReset />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        {
          path: 'TrainingVideo',
          children: [
            { element: <Navigate to="/dashboard/TrainingVideo/list" replace />, index: true },
            {
              path: 'list',
              element: <TrainingVideoList />,
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['TrainingVideo-Create']}>
                  <TrainingVideoCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'play',
              element: <TrainingVideoHeader />,
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['TrainingVideo-Update']}>
                  <TrainingVideoCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        // EmployeeD Routs
        {
          path: 'Employee',
          children: [
            { element: <Navigate to="/dashboard/Employee/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['EmployeeProfile-GetList']}>
                  <EmployeeList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['EmployeeProfile-Create']}>
                  <EmployeeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['EmployeeProfile-Update']}>
                  <EmployeeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                // <PermissionBasedGuard hasContent permissions={['Card-Update']}>
                <EmployeeDetailHeader />
                // </PermissionBasedGuard>
              ),
            },
          ],
        },

        // ContractDetails Routs
        {
          path: 'ContractDetails',
          children: [
            { element: <Navigate to="/dashboard/ContractDetails/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractDetails-GetList']}>
                  <ContractDetailsList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractDetails-Create']}>
                  <ContractDetailsCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractDetails-Update']}>
                  <ContractDetailsCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        // PositionTitle Routs
        {
          path: 'PositionTitle',
          children: [
            { element: <Navigate to="/dashboard/PositionTitle/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['PositionTitle-GetList']}>
                  <PositionTitleList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['PositionTitle-Create']}>
                  <PositionTitleCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['PositionTitle-Update']}>
                  <PositionTitleCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        {
          path: 'JobPosition',
          children: [
            { element: <Navigate to="/dashboard/JobPosition/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['JobPosition-GetList']}>
                  <JobPositionList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['JobPosition-Create']}>
                  <JobPositionCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['JobPosition-Update']}>
                  <JobPositionCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //Project Priority duplicated

        {
          path: 'District',
          children: [
            {
              element: (
                <PermissionBasedGuard hasContent permissions={['District-GetList']}>
                  <Navigate to="/dashboard/District/list" replace />
                </PermissionBasedGuard>
              ),
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-GetList']}>
                  <DistrictList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'district/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-Create']}>
                  <DistrictCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'district/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['District-Update']}>
                  <DistrictCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //HR
        //ContractType
        {
          path: 'ContractType',
          children: [
            {
              element: <Navigate to="/dashboard/ContractType/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractType-GetList']}>
                  <ContractTypeList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractType-Create']}>
                  <ContractTypeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ContractType-Update']}>
                  <ContractTypeCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //POS
        {
          path: 'POS',
          children: [
            {
              element: <Navigate to="/dashboard/Resturant/POS/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['POS-GetList']}>
                  <POSList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['POS-Create']}>
                  <POSCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['POS-Update']}>
                  <POSCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        // Application
        {
          path: 'Application',
          children: [
            { element: <Navigate to="/dashboard/Application/list" replace />, index: true },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Application-GetList']}>
                  <ApplicationList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'ApplicationCreate/new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Application-Create']}>
                  <ApplicationCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'Application/edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Application-Update']}>
                  <ApplicationCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },

        //#region choqorak

        //#region Block
        {
          path: 'Block',
          children: [
            {
              element: <Navigate to="/dashboard/Block/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Block-GetList']}>
                  <BlockList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Block-Create']}>
                  <BlockCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Block-Update']}>
                  <BlockCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Block-GetDetail']}>
                  <BlockDetailHeader />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region ContractInfo
        {
          path: 'ContractInfo',
          children: [
            {
              element: <Navigate to="/dashboard/ContractInfo/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList']}>
                  <ContractInfoList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'approved',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_approved']}>
                  <ContractInfoApprovedList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'unapproved',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_unapproved']}>
                  <ContractInfoUnApprovedList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'abouttoexpired',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_about_to_expire']}>
                  <ContractInfoAboutToExpiredList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'expired',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_expired']}>
                  <ContractInfoExpiredList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'terminated',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_terminated']}>
                  <ContractInfoTerminatedList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'activeContract',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetList_active']}>
                  <ContractInfoActiveContractList />
                </PermissionBasedGuard>
              ),
            },

            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-Create']}>
                  <ContractInfoCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-Update']}>
                  <ContractInfoCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'terminate',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-Terminate']}>
                  <ContractInfoTerminateCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'ExpirationSettlement',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-ExpirationSettlement']}>
                  <ExpirationSettlementCreate />
                </PermissionBasedGuard>
              ),
            },

            {
              path: 'create',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-Create']}>
                  <ContractInfoCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetDetail']}>
                  <ContractInfoDetailHeader />
                </PermissionBasedGuard>
              ),
            },

            {
              path: 'pdfviewer',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetDetail']}>
                  <PDFViewer />
                </PermissionBasedGuard>
              ),
            }, {
              path: 'pdfdiscountviewer',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetDetail']}>
                  <DiscountDocView />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'report',
              element: (
                <PermissionBasedGuard hasContent permissions={['Contract-GetContractReport']}>
                  <ContractInfoReportIndex />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion
        //#region Customer
        {
          path: 'Customer',
          children: [
            {
              element: <Navigate to="/dashboard/Customer/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Customer-GetList']}>
                  <CustomerList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Customer-Create']}>
                  <CustomerCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Customer-Update']}>
                  <CustomerCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Customer-GetDetail']}>
                  <CustomerDetailHeader />
                </PermissionBasedGuard>
              ),
            },
            // {
            //   path: 'report',
            //   element: (
            //     <PermissionBasedGuard hasContent permissions={['ContractInfo-Update']}>
            //       <CustomerReportIndex />
            //     </PermissionBasedGuard>
            //   ),
            // },
          ],
        },
        //#endregion

        //#region ContractPayment
        {
          path: 'RentPayment',
          children: [
            {
              element: <Navigate to="/dashboard/RentPayment/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['RentPayment-GetList']}>
                  <RentPaymentList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['RentPayment-Create']}>
                  <RentPaymentCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['RentPayment-Update']}>
                  <RentPaymentCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'RentPaymentSearch',
              element: (
                <PermissionBasedGuard hasContent permissions={['RentPayment-GetList']}>
                  <RentPaymentSearchIndex />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'report',
              element: (
                <PermissionBasedGuard hasContent permissions={['RentPayment-GetRentPaymentReport']}>
                  <RentPaymentReportIndex />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region Discount
        {
          path: 'ElectricityPayment',
          children: [
            {
              element: <Navigate to="/dashboard/ElectricityPayment/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricityPayment-GetList']}>
                  <ElectricityPaymentList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'consumption',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricityPayment-GetList']}>
                  <ElectricityConsumptionList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'report',
              element: (
                <PermissionBasedGuard
                  hasContent
                  permissions={['ElectricityPayment-GetElectricityPaymentReport']}
                >
                  <ElectricityPaymentReportIndex />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region Income
        {
          path: 'Income',
          children: [
            {
              element: <Navigate to="/dashboard/Income/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Income-GetList']}>
                  <IncomeList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Income-Create']}>
                  <IncomeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Income-Create']}>
                  <IncomeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Income-GetDetail']}>
                  <IncomeDetailHeader />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'report',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-GetList']}>
                  <IncomeReportIndex />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

          //#region FinancialPayment
        {
          path: 'FinancialPayment',
          children: [
            {
              element: <Navigate to="/dashboard/FinancialPayment/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['FinancialPayment-GetList']}>
                  <FinancialPaymentList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['FinancialPayment-Create']}>
                  <FinancialPaymentCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['FinancialPayment-Create']}>
                  <FinancialPaymentCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['FinancialPayment-GetDetail']}>
                  <FinancialPaymentDetailHeader />
                </PermissionBasedGuard>
              ),
            },
           
          ],
        },
        //#endregion

        //#region ChoqorakMap
        {
          path: 'choqorakmap',
          children: [
            {
              element: <Navigate to="/dashboard/choqorakmap/map`" replace />,
              index: true,
            },
            {
              path: 'map',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-GetShopForMap']}>
                  <ChoqoralMap />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region Shop
        {
          path: 'Shop',
          children: [
            {
              element: <Navigate to="/dashboard/Shop/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-GetList']}>
                  <ShopList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-Create']}>
                  <ShopCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-Update']}>
                  <ShopCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-GetDetail']}>
                  <ShopDetailHeader />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'report',
              element: (
                <PermissionBasedGuard hasContent permissions={['Shop-GetShopReport']}>
                  <ShopReportIndex />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region ElectricBox
        {
          path: 'ElectricBox',
          children: [
            {
              element: <Navigate to="/dashboard/ElectricBox/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricBox-GetList']}>
                  <ElectricBoxList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricBox-Create']}>
                  <ElectricBoxCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricBox-Update']}>
                  <ElectricBoxCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricBox-GetDetails']}>
                  <ElectricBoxDetailHeader />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region ElectricMeter
        {
          path: 'ElectricMeter',
          children: [
            {
              element: <Navigate to="/dashboard/ElectricMeter/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricMeter-GetList']}>
                  <ElectricMeterList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricMeter-Create']}>
                  <ElectricMeterCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricMeter-Update']}>
                  <ElectricMeterCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['ElectricMeter-GetDetails']}>
                  <ElectricMeterDetailHeader />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region Floor
        {
          path: 'Floor',
          children: [
            {
              element: <Navigate to="/dashboard/Floor/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Floor-GetList']}>
                  <FloorList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Floor-Create']}>
                  <FloorCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Floor-Update']}>
                  <FloorCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'detail',
              element: (
                <PermissionBasedGuard hasContent permissions={['Floor-GetDetails']}>
                  <FloorDetailHeader />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region IncomeCategory
        {
          path: 'IncomeCategory',
          children: [
            {
              element: <Navigate to="/dashboard/IncomeCategory/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['IncomeCategory-GetList']}>
                  <IncomeCategoryList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['IncomeCategory-Create']}>
                  <IncomeCategoryCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['IncomeCategory-Update']}>
                  <IncomeCategoryCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region ShopContractType
        {
          path: 'ShopContractType',
          children: [
            {
              element: <Navigate to="/dashboard/ShopContractType/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopContractType-GetList']}>
                  <ShopContractTypeList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopContractType-Create']}>
                  <ShopContractTypeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopContractType-Update']}>
                  <ShopContractTypeCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region Status
        {
          path: 'Status',
          children: [
            {
              element: <Navigate to="/dashboard/Status/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['Status-GetList']}>
                  <StatusList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['Status-Create']}>
                  <StatusCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['Status-Update']}>
                  <StatusCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region ShopType
        {
          path: 'ShopType',
          children: [
            {
              element: <Navigate to="/dashboard/ShopType/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopType-GetList']}>
                  <ShopTypeList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopType-Create']}>
                  <ShopTypeCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['ShopType-Update']}>
                  <ShopTypeCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#region TermsAndCondition
        {
          path: 'TermsAndCondition',
          children: [
            {
              element: <Navigate to="/dashboard/TermsAndCondition/list" replace />,
              index: true,
            },
            {
              path: 'list',
              element: (
                <PermissionBasedGuard hasContent permissions={['TermsAndCondition-GetList']}>
                  <TermsAndConditionList />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'new',
              element: (
                <PermissionBasedGuard hasContent permissions={['TermsAndCondition-Create']}>
                  <TermsAndConditionCreate />
                </PermissionBasedGuard>
              ),
            },
            {
              path: 'edit',
              element: (
                <PermissionBasedGuard hasContent permissions={['TermsAndCondition-Update']}>
                  <TermsAndConditionCreate />
                </PermissionBasedGuard>
              ),
            },
          ],
        },
        //#endregion

        //#endregion

        {
          path: 'invoice',
          children: [
            { element: <Navigate to="/dashboard/invoice/list" replace />, index: true },
            { path: 'list', element: <InvoiceList /> },
            { path: ':id', element: <InvoiceDetails /> },
            { path: ':id/edit', element: <InvoiceEdit /> },
            // { path: 'new', element: <InvoiceCreate /> },
          ],
        },

        {
          path: 'blog',
          children: [
            { element: <Navigate to="/dashboard/blog/posts" replace />, index: true },
            { path: 'posts', element: <BlogPosts /> },
            { path: 'post/:title', element: <BlogPost /> },
            { path: 'new', element: <BlogNewPost /> },
          ],
        },
        {
          path: 'mail',
          children: [
            { element: <Navigate to="/dashboard/mail/all" replace />, index: true },
            { path: 'label/:customLabel', element: <Mail /> },
            { path: 'label/:customLabel/:mailId', element: <Mail /> },
            { path: ':systemLabel', element: <Mail /> },
            { path: ':systemLabel/:mailId', element: <Mail /> },
          ],
        },

        { path: 'calendar', element: <Calendar /> },
        { path: 'kanban', element: <Kanban /> },
        { path: 'permission-denied', element: <PermissionDenied /> },
      ],
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: 'coming-soon', element: <ComingSoon /> },
        { path: 'maintenance', element: <Maintenance /> },
        { path: 'pricing', element: <Pricing /> },
        { path: 'payment', element: <Payment /> },
        { path: '500', element: <Page500 /> },
        { path: '404', element: <Page404 /> },
        { path: '403', element: <Page403 /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [{ element: <LoginPage />, index: true }],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// AUTHENTICATION
const Login = Loadable(lazy(() => import('../pages/auth/Login')));
const Register = Loadable(lazy(() => import('../pages/auth/Register')));
const ResetPassword = Loadable(lazy(() => import('../pages/auth/ResetPassword')));
const NewPassword = Loadable(lazy(() => import('../pages/auth/NewPassword')));
const VerifyCode = Loadable(lazy(() => import('../pages/auth/VerifyCode')));

// DASHBOARD

// GENERAL
const GeneralApp = Loadable(lazy(() => import('../pages/dashboard/GeneralApp')));
const GeneralEcommerce = Loadable(lazy(() => import('../pages/dashboard/GeneralEcommerce')));
const GeneralAnalytics = Loadable(lazy(() => import('../pages/dashboard/GeneralAnalytics')));
const GeneralBanking = Loadable(lazy(() => import('../pages/dashboard/GeneralBanking')));
const GeneralBooking = Loadable(lazy(() => import('../pages/dashboard/GeneralBooking')));

// ITSMS

// User
const UserList = Loadable(lazy(() => import('../sections/@dashboard/user/userList/UserList')));
const UserLogList = Loadable(
  lazy(() => import('../sections/@dashboard/user/userList/UserLogList'))
);
const UserCreate = Loadable(lazy(() => import('../sections/@dashboard/user/userForm/UserCreate')));
const UserDetailHeader = Loadable(
  lazy(() => import('../sections/@dashboard/user/userForm/UserDetailHeader'))
);

// Language
const LanguageList = Loadable(
  lazy(() => import('../sections/@dashboard/language/languageList/LanguageList'))
);
const LanguageCreate = Loadable(
  lazy(() => import('../sections/@dashboard/language/languageForm/LanguageCreate'))
);

// Roles
const RoleList = Loadable(lazy(() => import('../sections/@dashboard/role/roleList/RoleList')));
const RoleCreate = Loadable(lazy(() => import('../sections/@dashboard/role/roleForm/RoleCreate')));

// Permission
const PermissionList = Loadable(
  lazy(() => import('../sections/@dashboard/permission/permissionList/PermissionList'))
);
const PermissionFrom = Loadable(
  lazy(() => import('../sections/@dashboard/permission/permissionForm/PermissionFrom'))
);

//Employee rout
const EmployeeList = Loadable(
  lazy(() => import('../sections/@dashboard/Employee/EmployeeList/EmployeeList'))
);

const EmployeeCreate = Loadable(
  lazy(() => import('../sections/@dashboard/Employee/EmployeeForm/EmployeeCreate'))
);

//HR
//ContractType
const ContractTypeList = Loadable(
  lazy(() => import('../sections/@dashboard/ContractType/ContractTypeList/ContractTypeList'))
);

const ContractTypeCreate = Loadable(
  lazy(() => import('../sections/@dashboard/ContractType/ContractTypeForm/ContractTypeCreate'))
);

// ECOMMERCE
const EcommerceShop = Loadable(lazy(() => import('../pages/dashboard/EcommerceShop')));
const EcommerceProductDetails = Loadable(
  lazy(() => import('../pages/dashboard/EcommerceProductDetails'))
);
const EcommerceProductList = Loadable(
  lazy(() => import('../pages/dashboard/EcommerceProductList'))
);
const EcommerceProductCreate = Loadable(
  lazy(() => import('../pages/dashboard/EcommerceProductCreate'))
);
const EcommerceCheckout = Loadable(lazy(() => import('../pages/dashboard/EcommerceCheckout')));

// INVOICE
const InvoiceList = Loadable(lazy(() => import('../pages/dashboard/InvoiceList')));
const InvoiceDetails = Loadable(lazy(() => import('../pages/dashboard/InvoiceDetails')));
// const InvoiceCreate = Loadable(lazy(() => import('../pages/dashboard/InvoiceCreate')));
const InvoiceEdit = Loadable(lazy(() => import('../pages/dashboard/InvoiceEdit')));

// BLOG
const BlogPosts = Loadable(lazy(() => import('../pages/dashboard/BlogPosts')));
const BlogPost = Loadable(lazy(() => import('../pages/dashboard/BlogPost')));
const BlogNewPost = Loadable(lazy(() => import('../pages/dashboard/BlogNewPost')));

// APP
const Mail = Loadable(lazy(() => import('../pages/dashboard/Mail')));
const Calendar = Loadable(lazy(() => import('../pages/dashboard/Calendar')));
const Kanban = Loadable(lazy(() => import('../pages/dashboard/Kanban')));

// TEST RENDER PAGE BY ROLE
const PermissionDenied = Loadable(lazy(() => import('../pages/dashboard/PermissionDenied')));

// MAIN
const LoginPage = Loadable(lazy(() => import('../pages/auth/Login')));
const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
const Pricing = Loadable(lazy(() => import('../pages/Pricing')));
const Payment = Loadable(lazy(() => import('../pages/Payment')));
const Page500 = Loadable(lazy(() => import('../pages/Page500')));
const Page403 = Loadable(lazy(() => import('../pages/Page403')));
const Page404 = Loadable(lazy(() => import('../pages/Page404')));
